module.exports = __webpack_public_path__ + "img/zhangxinjun.7c91d52e.jpg";